import React from "react";
import PropTypes from "prop-types";

const GroupsInfoFaqRow = ({ question, answer, isExpanded }) => {
  return (
    <>
      <div className="groups-info__question body-2 tw-font-medium tw-flex tw-items-center tw-justify-between">
        <div className="groups-info__question--text">{question}</div>
        <div
          className={`lc-icon lc-icon-sm ${
            isExpanded ? "lc-icon-up" : "lc-icon-down"
          }`}
        />
      </div>
      <div className="groups-info__answer body-2">{answer}</div>
    </>
  );
};
GroupsInfoFaqRow.propTypes = {
  answer: PropTypes.node.isRequired,
  isExpanded: PropTypes.bool,
  question: PropTypes.string.isRequired
};

GroupsInfoFaqRow.defaultProps = {
  isExpanded: false
};

export default GroupsInfoFaqRow;
